import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiService } from "./base/api.service";

@Injectable({
    providedIn: 'root',
})
export class InfosService {

    private readonly baseUrl = 'infos/';

    public onChangePolPrice: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);

    constructor(private apiService: ApiService) { }

    getPolPrice(): Observable<number | null> {
        return this.apiService.get<number | null>(this.baseUrl + 'eth-price');
    }
}